module.exports = __webpack_public_path__ + "static/media/Entrance-2.a9bc0336.webp";